import { InputLabel, MenuItem } from '@mui/material';
import { memo, useEffect } from 'react';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { Operation } from 'shell/view-models/operation';
import { DateTime } from 'luxon';
import { ValueDomainType } from 'shell/models/value-domain-type';
import { DomainType } from 'civil-status/constants/domain';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { ItemVM } from 'shell/view-models/item';

interface ListEmergencyRegisterProps {
  disabled?: boolean;
  value?: string;
  onChange: (item?: ItemVM) => void;
  error?: boolean;
  required?: boolean;
  label?: string;
  id?: string;
  fromDate?: DateTime | null;
  tipoEvento?: string;
}

export interface MunicipalityAnscVM {
  id?: string;
  description: string;
  descriptionAnpr?: string;
  province?: string;
  provinceCode?: string;
  startDate?: string;
  endDate?: string;
  locality?: string;
  istatCode?: string;
}

const ListEmergencyRegisterComponent = ({
  disabled,
  onChange,
  required,
  value,
  error,
  label = 'Registro di emergenza',
  id = 'emergencyRegister',
  tipoEvento,
}: ListEmergencyRegisterProps): React.ReactElement => {
  const [dataDominio, getDataDominio] = useHttpFetch<
    HttpResponse<Array<ValueDomainType>>,
    Array<ItemVM>
  >('', {
    onBootstrap: false,
    options: {
      method: 'GET',
      loading: true,
      errorCatching: true,
    },
    transformer: (response) => {
      return response.data.payload.map((el) => ({
        id: el?.key?.idValore || '',
        value: el.valore || '',
      }));
    },
  });

  useEffect(() => {
    let url = `${__ACT_API_URL__}/valori-dominio-atti?filters=idDominio:${DomainType.EmergencyRegister}:${Operation.EQUALS}`;

    if (tipoEvento) {
      url = `${url}&filters=tipoEvento:${tipoEvento}:${Operation.EQUALS}`;
    }

    getDataDominio({ url });
  }, [tipoEvento]);

  const data = (dataDominio.data as unknown as Array<ItemVM>) || [];

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={`${id}-label`}>
        {required ? `${label} *` : `${label}`}
      </InputLabel>
      <PmiSelect
        labelId={`${id}-label`}
        id={id}
        name={id}
        value={value}
        label={required ? `${label} *` : `${label}`}
        onChange={(event) => {
          onChange(data.find((service) => service.id === event.target.value) as ItemVM);
        }}
        disabled={disabled}
        error={error}
      >
        {required ? undefined : (
          <MenuItem value="">
            <em>Nessuno</em>
          </MenuItem>
        )}
        {data.map((service) => (
          <MenuItem key={service.id} value={service.id}>
            {service.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListEmergencyRegisterComponent.displayName = 'Municipality ANSC list component';

const ListEmergencyRegister = memo(ListEmergencyRegisterComponent);

export default ListEmergencyRegister as typeof ListEmergencyRegisterComponent;
